const firebaseConfig = {
  apiKey: "AIzaSyC2MgbUUUNrdR6RZ0ROmTXa8eHlOJTk8Xc",
  authDomain: "ibn-sina-hospital-64898.firebaseapp.com",
  projectId: "ibn-sina-hospital-64898",
  storageBucket: "ibn-sina-hospital-64898.appspot.com",
  messagingSenderId: "609247026186",
  appId: "1:609247026186:web:41880d114637b07ffe13f3",
};

export default firebaseConfig;
